import Pqp from "../../../3x1010/Pqp.js";

export default class FramesPlayer {
	constructor(clip, anim, callback, callbackEndAnimation) {
		this.clip = clip;
		this.anim = anim;
		this.idto = -1;
		this.currentFrame = 0;
		this.frames = this.anim.frames;
		this.callback = callback;
		this.callbackEndAnimation = callbackEndAnimation;
	}

	start() {
		if (this.anim.flip) {
			this.clip.addClass("sprite-flip-w");
		} else {
			this.clip.removeClass("sprite-flip-w");
		}
		this.currentFrame = 0;
		this.showNextFrame();
	}
	showNextFrame() {
		//console.log(this.clip)
		let sprite = this.frames[this.currentFrame].sprite;
		let time = this.frames[this.currentFrame].time;
		this.clip.css("background-image", "url('" + sprite + "')");
		this.currentFrame++;
		if (this.currentFrame === this.frames.length) {
			this.currentFrame = 0;
		}
		if (!Pqp.isNullOrEmpty(this.frames[this.currentFrame].goto)) {
			this.dispatch({ type: FramesPlayer.EVENT_GOTO_ANIMATION, data: { id: this.frames[this.currentFrame].goto } });
			if (this.callbackEndAnimation) {
				this.callbackEndAnimation.call(null);
			}

		} else {
			if (time !== -1) {
				this.idto = setTimeout(this.showNextFrame.bind(this), time);
			} else {
				if (this.callbackEndAnimation) {
					this.callbackEndAnimation.call(null);
				}
			}
		}
	}

	destroy() {
		clearTimeout(this.idto);
	}

	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}


}

FramesPlayer.EVENT_GOTO_ANIMATION = "eventGotoAnimation";